import React, { useState, useEffect } from 'react';
import { Alert } from 'antd';
import authService from '../services/auth';

const TokenCountdown = () => {
  const [showCountdown, setShowCountdown] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    // 设置倒计时回调
    authService.setCountdownCallback((seconds) => {
      setSecondsLeft(seconds);
      setShowCountdown(true);
    });

    // 清理函数
    return () => {
      authService.setCountdownCallback(null);
    };
  }, []);

  // 如果没有倒计时，不显示任何内容
  if (!showCountdown || secondsLeft <= 0) {
    return null;
  }

  return (
    <Alert
      message={`登录即将过期！剩余 ${secondsLeft} 秒`}
      type="warning"
      showIcon
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 1000,
      }}
    />
  );
};

export default TokenCountdown;
